<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:24:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 18:39:52
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/tableCells/materialInfoCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
		<MaterialInfo @play="handleVideoClick" :row="row" ></MaterialInfo>
        <videoPlayer controlsList="nodownload" ref="videoPlayer" controls muted videoWidth="800" videoHeight="600" />
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
import MaterialInfo from '../materialInfo/materialInfo.vue';
import { batchDownload } from '@/api/contentLibray.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
    components:{
		MaterialInfo,

    },
	computed: {},
	props: {},

	mounted() {},

	methods:{
		async handleVideoClick() {
			this.$refs.videoPlayer.show(this.row.link);
		},
	}
};
</script>
<style lang="less" scoped></style>
